export const HOSTNAME: string =
  window?.location?.host === "localhost:3000" ? "http://localhost:8010" : ""; //change this to http://localhost:8010 for local deployment

/**
 * WebSocket の接続先ベース URL。
 * 仕様書「7. 環境別接続 URL 早見表」に合わせ、HOSTNAME を ws:// / wss:// に読み替える。
 * - Local:      HOSTNAME="http://localhost:8010"      → "ws://localhost:8010"
 * - Staging:    HOSTNAME="" のため location.origin を fallback → "wss://stg.soremo.jp"
 * - Production: HOSTNAME="" のため location.origin を fallback → "wss://soremo.jp"
 */
export const WS_HOSTNAME: string = (HOSTNAME || window?.location?.origin || "")
  .replace(/^http/i, "ws");
